export enum CarLocationType {
  STATION = 'STATION',
  STREET = 'STREET',
  IN_USE = 'IN_USE',
}
